<template>
  <b-col cols="2" :md="toolbarCols" class="pl-0 rounded-left rounded-lg" :class="{'bg-light': toolbarMode === null, 'toolbar-float': isOnMobile}">
    <div class="d-flex flex-column align-items-center py-4 px-2" v-if="!toolbarMode" style="gap: 15px">
      <template v-for="(item, index) in itemsToShow">
        <b-button
          :key="index"
          variant="outline-primary"
          pill v-b-popover.hover.left="item.title"
          @click="item.click(item.id)"
          v-if="item"
        >
          <i class="mdi" :class="item.icon" style="font-size: 1.2rem"></i>
        </b-button>
        <hr :key="index" class="w-100" v-if="!item">
      </template>
    </div>

    <div class="h-100" :style="toolbarHeight" v-if="toolbarMode">
      <template v-for="(item, index) in itemsToRender">
        <Component
          v-if="toolbarMode === item.id"
          :componentId="item.id"
          :ref="item.id"
          :key="index"
          :is="item.component"
          :title="item.title"
          :icon="item.icon"
          v-bind="config[item.id]"
          @close="toolbarMode = null"
          v-on="$listeners"
        />
      </template>
    </div>
    <Component
      v-for="(item, index) in itemsModalToRender"
      :key="index"
      v-bind="config[item.id]"
      :is="item.component"
      :ref="item.id"
      :title="item.title"
    />
  </b-col>
</template>

<script>
// Components
import LmProcessHistory from './components/LmProcessHistory'
import LmComments from './components/LmComments'
import LmAllDocuments from './components/LmProcessAllDocuments'
import LmContentTemplates from './components/LmContentTemplates'
import LmProcessStatus from './components/LmProcessStatus'
import LmProcessPasses from './components/LmProcessPasses'
import LmProcessLink from './components/LmProcessLink'
import LmDocumentMovements from './components/LmDocumentMovements'
import LmDocumentPreview from './components/LmDocumentPreview'
import LmDocumentModel from './components/LmDocumentModel'
import LmDocumentRecipients from './components/LmDocumentRecipients'
import LmDocumentViewers from './components/LmDocumentViewers'
import LmAuditMovements from './components/LmAuditMovements'
import LmLogMovements from './components/LmLogMovements'
import LmTags from './components/LmTags'

export default {
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    toolbarHeight: {
      type: String,
      default: 'height: 700px'
    },
    items: {
      type: Array,
      defaultt: () => []
    },
    config: {
      type: Object,
      required: true
    }
  },
  components: {
    LmProcessHistory,
    LmProcessStatus,
    LmProcessPasses,
    LmProcessLink,
    LmComments,
    LmAllDocuments,
    LmContentTemplates,
    LmDocumentMovements,
    LmDocumentPreview,
    LmDocumentModel,
    LmDocumentRecipients,
    LmDocumentViewers,
    LmAuditMovements,
    LmLogMovements,
    LmTags
  },
  data () {
    return {
      toolbarMode: null,
      screenWidth: innerWidth
    }
  },
  computed: {
    // Hago que el cambio a mobile sea dinámico y que no haga falta recargar para que se aplique
    // https://stackoverflow.com/questions/47219272/how-can-i-use-window-size-in-vue-how-do-i-detect-the-soft-keyboard
    isOnMobile () {
      if (this.screenWidth < 768 && !!this.toolbarMode) {
        return true
      }
      return false
    },
    toolbarCols () {
      if (this.toolbarMode) {
        return this.itemsConfig[this.toolbarMode].cols
      }
      return 1
    },
    itemsConfig () {
      return {
        comments: {
          id: 'comments',
          icon: 'mdi-comment-text-outline',
          title: 'Comentarios',
          component: 'LmComments',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        contentTemplates: {
          id: 'contentTemplates',
          icon: 'mdi-content-duplicate',
          title: 'Templates de contenido',
          component: 'LmContentTemplates',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        allDocuments: {
          id: 'allDocuments',
          icon: 'mdi-file-document-outline',
          title: 'Todos los documentos',
          component: 'LmAllDocuments',
          cols: 4,
          click: (id) => this.updateToolbarMode(id)
        },
        allInternalDocuments: {
          id: 'allInternalDocuments',
          icon: 'mdi-text-box-outline',
          title: 'Todos los documentos internos',
          component: 'LmAllDocuments',
          cols: 4,
          click: (id) => this.updateToolbarMode(id)
        },
        processHistory: {
          id: 'processHistory',
          icon: 'mdi-swap-horizontal',
          title: 'Historial',
          component: 'LmProcessHistory',
          cols: 4,
          click: (id) => this.updateToolbarMode(id)
        },
        processMovements: {
          id: 'processMovements',
          icon: 'mdi-timeline-check-outline',
          title: 'Movimientos',
          component: 'LmProcessHistory',
          cols: 4,
          click: (id) => this.updateToolbarMode(id)
        },
        processPasses: {
          id: 'processPasses',
          icon: 'mdi-arrow-right-bold',
          title: 'Nuevo pase',
          component: 'LmProcessPasses',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        processStatus: {
          id: 'processStatus',
          icon: 'mdi-flag-outline',
          title: 'Nuevo estado',
          component: 'LmProcessStatus',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        processLink: {
          id: 'processLink',
          icon: 'mdi-link-variant',
          title: 'Asociar trámite',
          component: 'LmProcessLink',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        documentMovements: {
          id: 'documentMovements',
          icon: 'mdi-timeline-check-outline',
          title: 'Movimientos',
          component: 'LmDocumentMovements',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        documentPreview: {
          id: 'documentPreview',
          icon: 'mdi-text-box-search-outline',
          title: 'Vista previa',
          component: 'LmDocumentPreview',
          displayType: 'modal',
          click: (id) => {
            this.$refs.documentPreview[0].onPreview()
          }
        },
        documentModel: {
          id: 'documentModel',
          icon: 'mdi-file-export-outline',
          title: 'Documento completo',
          component: 'LmDocumentModel',
          displayType: 'modal',
          click: (id) => {
            this.$refs.documentModel[0].onPreview()
          }
        },
        documentRecipients: {
          id: 'documentRecipients',
          icon: 'mdi-file-send-outline',
          title: 'Destinatarios',
          component: 'LmDocumentRecipients',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        documentViewers: {
          id: 'documentViewers',
          icon: 'mdi-file-eye-outline',
          title: 'Visualizadores',
          component: 'LmDocumentViewers',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        auditMovements: {
          id: 'auditMovements',
          icon: 'mdi-history',
          title: 'Auditoría',
          component: 'LmAuditMovements',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        logMovements: {
          id: 'logMovements',
          icon: 'mdi-lock-clock',
          title: 'Historial de Logueo',
          component: 'LmLogMovements',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        },
        tags: {
          id: 'tags',
          icon: 'mdi-tag-multiple',
          title: 'Tags',
          component: 'LmTags',
          cols: 3,
          click: (id) => this.updateToolbarMode(id)
        }
      }
    },
    // Componentes que son modales
    itemsModalToRender () {
      return this.itemsToRender.filter(el => el?.displayType === 'modal')
    },
    // Componente a renderizar (filtro los nulls)
    itemsToRender () {
      return this.itemsToShow.filter(el => el)
    },
    // Icono a mostrar
    itemsToShow () {
      if (this.items.length) {
        return this.items.map(el => {
          if (el) {
            return { ...this.itemsConfig[el] }
          }
          return el
        })
      }
      return []
    }
  },
  methods: {
    onScreenResize () {
      this.screenWidth = screen.width
    },
    updateToolbarMode (id) {
      this.toolbarMode = id
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onScreenResize)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onScreenResize)
  }
}
</script>

<style lang="sass" scoped>
.toolbar-float
  position: absolute
  flex: 75% 0 0
  max-width: 75%
  right: 0
  height: 85vh
  z-index: 1
</style>
